
const UserListMore = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="10" fill="#F2F4F7" />
        <circle cx="6" cy="10" r="1" fill="#5C6473" />
        <circle cx="10" cy="10" r="1" fill="#5C6473" />
        <circle cx="14" cy="10" r="1" fill="#5C6473" />
    </svg>);
export default UserListMore;
